/* eslint-disable max-lines */
import {
  AaaGameInformationAvailabilityDataType,
  AaaGameInformationConceptDetailsDataType,
  AaaGameInformationConfigurationsDataType,
  AaaGameInformationDistributionInformationDataType,
  AaaGameInformationGameExpectationsDataType,
  AaaGameInformationSupplementaryDataType,
  AaaGameInformationTechnicalCapabilitiesDataType,
  AaaGameInformationUgcDataType,
  AaaGameInformationXboxNetworkDataType,
  CommonIntroContactDataType,
  CommonIntroShippingDataType,
  CommonIntroStudioDataTypeBase,
  GameInformationConceptDetailsDataType,
  GameInformationConfigurationsDataType,
  GameInformationGameExpectationsDataType,
  GameInformationPricingAndAvailabilityDataType,
  GameInformationSupplementaryDataType,
  GameInformationTechnicalCapabilitiesDataType,
  GameInformationUgcDataType,
  GameInformationXboxNetworkDataType,
  IdXboxIntroContactDataType,
  IdXboxIntroStudioDataType,
  IntroBusinessContactCustomerDataType,
  PitchInformationAboutYourGameDataType,
  PitchInformationAboutYourselfDataType,
  PitchInformationAskForXboxDataType,
  PitchInformationPublisherDeveloperDataType,
} from "../../models/forms";

const emptyCommonIntroShippingDataType: CommonIntroShippingDataType = {
  shippingAddressLine1: "",
  shippingAddressLine2: "",
  shippingCity: "",
  shippingStateRegion: "",
  shippingPostalCode: "",
  shippingCountryOrRegion: "",
  shippingPhone: "",
};

const emptyIntroBusinessContactCustomerDataType: IntroBusinessContactCustomerDataType = {
  businessContactCustomerEmail: "",
  businessContactCustomerPhone: "",
  businessContactCustomerWebsite: "",
  businessContactCustomerAddressLine1: "",
  businessContactCustomerAddressLine2: "",
  businessContactCustomerCity: "",
  businessContactCustomerStateRegion: "",
  businessContactCustomerPostalCode: "",
  businessContactCustomerCountryOrRegion: "",
  useAddressInformationPreviouslyAddedForCustomers: false,
  isPublicContactInformationProvided: false,
};

const emptyCommonIntroContactDataType: CommonIntroContactDataType = {
  ...emptyCommonIntroShippingDataType,
  firstName: "",
  lastName: "",
  businessTitle: "",
  email: "",
  addressLine1: "",
  addressLine2: "",
  city: "",
  stateRegion: "",
  postalCode: "",
  countryOrRegion: "",
  phone: "",
  useDifferentShippingAddress: false,
};

const emptyCommonIntroStudioDataTypeBase: CommonIntroStudioDataTypeBase = {
  studioName: "",
  partnerCenterVerifiedStudioName: "",
  businessName: "",
  studioWebsite: "",
};

export const idXboxIntroContactInitialValues: IdXboxIntroContactDataType = {
  ...emptyCommonIntroContactDataType,
  ...emptyIntroBusinessContactCustomerDataType,
  isStarted: false,
};

export const idXboxIntroStudioInitialValues: IdXboxIntroStudioDataType = {
  ...emptyCommonIntroStudioDataTypeBase,
  businessNumber: "",
  publicTrailersLinks: [""],
  thisCompany: [],
  thisCompanyActsAs: [],
  middlewareEnginesUsed: "",
  dunsNumber: "",
  isStarted: false,
};

export const gameInfoConceptInitialValues: GameInformationConceptDetailsDataType = {
  gameTitle: "",
  codeName: "",
  genre: undefined,
  otherGenre: "",
  gameDevelopers: [""],
  hook: "",
  gameplayVideosLinks: [""],
  gameplayDetails: "",
  gameBuildLinks: [""],
  gameBuildKeys: [""],
  additionalLinks: [""],
  linksTable: "",
  gameplayDuration: "",
  itchIoLink: "",
  steamLink: "",
  levelsNumber: undefined,
  levelsDetails: "",
  isStarted: false,
};

export const gameInfoGameExpectationsInitialValues: GameInformationGameExpectationsDataType = {
  targetPlatforms: [],
  middleware: undefined,
  middlewareVersion: "",
  middlewareNotes: "",
  releaseNotes: "",
  isStarted: false,
};

export const gameInfoPricingAndAvailabilityInitialValues: GameInformationPricingAndAvailabilityDataType =
  {
    monetizationStrategy: "",
    suggestedRetailPrice: undefined,
    hasInGameStore: false,
    canPlayersTradeOrGiftItems: false,
    howItemsCanBeGifted: "",
    hasSubscriptionFee: false,
    howItWillGenerateMoney: "",
    inGamePricePoints: "",
    timeUntilAPlayerIsPromptedToPay: "",
    whatPlayersCanSpendOn: "",
    retentionMechanics: "",
    subscriptionModel: "",
    supportedLanguages: [],
    hasOtherLanguages: false,
    otherLanguages: "",
    anticipatedRatings: undefined,
    sensitiveContent: undefined,
    sensitiveContentDetails: "",
    isStarted: false,
  };

export const gameInfoTechnicalCapabilitiesInitialValues: GameInformationTechnicalCapabilitiesDataType =
  {
    anticipatedCapabilities: [],
    xboxSeriesXSVersionCapabilities: [],
    xboxSeriesXSAdvantage: "",
    isStarted: false,
  };

export const gameInfoConfigurationsInitialValues: GameInformationConfigurationsDataType = {
  localPlayerModes: [],
  onlinePlayerModes: [],
  crossPlay: [],
  isStarted: false,
};

export const gameInfoXboxNetworkInitialValues: GameInformationXboxNetworkDataType = {
  xboxNetworkFeatures: [],
  addOns: [],
  additionalContent: "",
  isStarted: false,
};

export const gameInfoUgcInitialValues: GameInformationUgcDataType = {
  hasUserGeneratedShareableContent: false,
  ugcDetails: "",
  isStarted: false,
};

export const gameInfoSupplementaryDataInitialValues: GameInformationSupplementaryDataType = {
  competitorTitles: [],
  devStudioExperience: [],
  teamMembersPreviousTitles: [],
  isStarted: false,
};

export const pitchInfoDeveloperPublisherInitialValues: PitchInformationPublisherDeveloperDataType =
  {
    nameCompanyOrganization: "",
    emailAddress: "",
    xboxContact: "",
    programConsiderationType: [],
    programConsiderationTypeOther: "",
    reasonOfGoodFit: "",
    specificAspectToPrototype: "",
    studioPointOfContact: "",
    studioSize: "",
    countryLocated: "",
    youHavePublisher: "",
    publisherName: "",
    studioEstablished: "",
    introductionDeckStudio: "",
    companyWebsite: "",
    signedUpIdXbox: "",
    kitAlready: "",
    launchedForConsole: "",
    listGameLaunchedOnConsole: "",
    isStarted: false,
  };

export const pitchAboutYourGameInitialValues: PitchInformationAboutYourGameDataType = {
  gameTitle: "",
  containsNftOrBlockchain: "",
  stageOfDevelopment: "",
  releasedForOtherPlatforms: "",
  releasedPlatforms: [],
  releasedPlatformsOther: "",
  releasedPlatformsDate: undefined,
  announced: "",
  targetedPlatforms: [],
  otherTargetedPlatforms: undefined,
  genre: [],
  genreOther: "",
  gameEngine: "",
  engineOther: "",
  businessModel: [],
  gameplayDuration: "",
  onlineMultiplayer: "",
  gameIntroDeckLink: "",
  otherInfoLinks: [],
  steamReleaseWindow: undefined,
  xboxReleaseWindow: undefined,
  buildLinks: "",
  videoLinks: "",
  gameDescription: "",
  targetAudience: "",
  competitorTitles: "",
  uniqueFactor: "",
  feelingsEvoked: "",
  pivotalMoment: "",
  postLaunchSupportPlans: "",
  sensitiveContent: "",
  sensitiveContentDetails: "",
  isStarted: false,
};

export const pitchAskForXboxInitialValues: PitchInformationAskForXboxDataType = {
  fundingSought: "",
  fundingSoughtDetails: "",
  otherSupportNeeded: "",
  isStarted: false,
};

export const pitchAboutYourselfInitialValues: PitchInformationAboutYourselfDataType = {
  studioBackground: "",
  activeInLocalGameDev: "",
  isStarted: false,
};

export const aaaGameInfoConceptInitialValues: AaaGameInformationConceptDetailsDataType = {
  gameTitle: "",
  codeName: "",
  genre: undefined,
  otherGenre: "",
  targetReleaseDate: "",
  gameDevelopers: [""],
  hook: "",
  gameplayVideosLinks: [""],
  gameplayDetails: "",
  gameBuildLinks: [""],
  gameBuildKeys: [""],
  additionalLinks: [""],
  linksTable: "",
  gameplayDuration: "",
  isStarted: false,
};

export const aaaGameInfoDistributionInformationInitialValues: AaaGameInformationDistributionInformationDataType =
  {
    shippingStrategy: "",
    hasInGameStore: false,
    canPlayersTradeOrGiftItems: false,
    howItemsCanBeGifted: "",
    hasSubscriptionFee: false,
    howItWillGenerateMoney: "",
    inGamePricePoints: "",
    timeUntilAPlayerIsPromptedToPay: "",
    whatPlayersCanSpendOn: "",
    retentionMechanics: "",
    subscriptionModel: "",
    isPrevIndependentlyPublished: null,
    prevReleases: "",
    isAssumingResponsibilitesForPrevPublishedGame: null,
    primaryPublisherName: "",
    isResponsibleForCertification: null,
    certResponsiblePartner: "",
    publishingTerritories: {},
    isStarted: false,
  };

export const aaaGameInfoGameExpectationsInitialValues: AaaGameInformationGameExpectationsDataType =
  {
    targetPlatforms: [],
    middleware: undefined,
    middlewareVersion: "",
    middlewareNotes: "",
    releaseNotes: "",
    releaseDatesByTerritory: {},
    demosTrialsBetas: {},
    isStarted: false,
  };

export const aaaGameInfoAvailabilityInitialValues: AaaGameInformationAvailabilityDataType = {
  supportedLanguages: [],
  hasOtherLanguages: false,
  otherLanguages: "",
  anticipatedRatings: {
    esrb: undefined,
    germanyUsk: undefined,
    taiwanCsrr: undefined,
    europeIsfe: undefined,
    australiaAcb: undefined,
    russiaPcbp: undefined,
    japanCero: undefined,
    koreaGrb: undefined,
    saudiArabiaGamr: undefined,
    brazilRatings: undefined,
    newZealandOflc: undefined,
  },
  sensitiveContent: "",
  sensitiveContentDetails: "",
  isStarted: false,
};

export const aaaGameInfoTechnicalCapabilitiesInitialValues: AaaGameInformationTechnicalCapabilitiesDataType =
  {
    anticipatedCapabilities: [],
    xboxSeriesXSVersionCapabilities: [],
    xboxSeriesXSAdvantage: "",
    xboxSeriesXPerfTargets: "",
    xboxSeriesSPerfTargets: "",
    isInternetConnectionRequired: false,
    internetConnectionDetails: undefined,
    spatial3dSound: undefined,
    isStarted: false,
  };

export const aaaGameInfoConfigurationsInitialValues: AaaGameInformationConfigurationsDataType = {
  localPlayerModes: [],
  onlinePlayerModes: [],
  hasServerBasedGamePlay: false,
  playersPerServer: "",
  publisherHostedServices: "",
  extraPeripheralsDetails: "",
  hasExtraPeripherals: false,
  requiredExtraPeripheralsDetails: "",
  requiresExtraPeripherals: false,
  isStarted: false,
};

export const aaaGameInfoXboxNetworkInitialValues: AaaGameInformationXboxNetworkDataType = {
  xboxNetworkFeatures: [],
  addOns: [],
  additionalContent: "",
  xboxLiveSignIn: [],
  otherXboxLiveSignIn: undefined,
  xboxAchievements: [],
  otherXboxAchievements: undefined,
  xboxCrossPlay: [],
  otherXboxCrossPlay: undefined,
  xboxCrossSaveProgress: [],
  otherXboxCrossSaveProgress: undefined,
  windowsCrossSaveProgress: [],
  otherWindowsCrossSaveProgress: undefined,
  isStarted: false,
};

export const aaaGameInfoUgcInitialValues: AaaGameInformationUgcDataType = {
  hasUserGeneratedShareableContent: false,
  ugcDetails: "",
  isStarted: false,
};

export const aaaGameInfoSupplementaryDataInitialValues: AaaGameInformationSupplementaryDataType = {
  competitorTitles: [],
  devStudioExperience: [],
  teamMembersPreviousTitles: [],
  isStarted: false,
};
